import styled from 'styled-components';

// @source
import { theme } from '../../styles';

const SchemaGenerator = styled.div`
  width: 100%;
  margin: 1.5rem 0;

  div[role="columnheader"],
  div[role="gridcell"] {
    padding-left: 4px;
    padding-right: 4px;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }
  }

  div[role="gridcell"] > span {
    width: 100%;
    display: block;
  }
`;

const Flex = styled.div`
  width: 100%;
  display: flex;
`;

const FlexItem = styled.div`
  flex: ${props => (props.nowrap ? '0' : '1')};
  white-space: ${props => (props.nowrap ? 'nowrap' : 'normal')};
  padding: 0 .25rem;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
`;

const Textbox = styled.div`
  width: 100%;

  label {
    display: none;
  }
`;

const Preferences = styled.div`
  padding-bottom: .5rem;
  border-bottom: 2px solid ${theme.border};
`;

export default {
  Flex,
  FlexItem,
  Preferences,
  SchemaGenerator,
  Textbox,
};
